import { collate } from 'pouchdb-collate';


// Based on https://github.com/alexdavid/scope-eval v0.0.3
// (source: https://unpkg.com/scope-eval@0.0.3/scope_eval.js)
// This is basically just a wrapper around new Function()

function scopeEval(source, scope) {
  var keys = [];
  var values = [];
  for (var key in scope) {
    if (scope.hasOwnProperty(key)) {
      keys.push(key);
      values.push(scope[key]);
    }
  }
  keys.push(source);
  return Function.apply(null, keys).apply(null, values);
}

var isArray = Array.isArray;
var toJSON = JSON.parse;


function evalFunctionWithEval(func, emit) {
  return scopeEval(
    "return (" + func.replace(/;\s*$/, "") + ");",
    {
      emit: emit,
      sum: () => { },
      log: () => { },
      isArray: isArray,
      toJSON: toJSON
    }
  );
}

function getMapFunction(ddoc, view) {
  if (!ddoc.views) {
    throw new Error("no views defined in the ddoc: " + toJSON(ddoc));
  }

  //TODO: When view isn't specified, find the view based on the docid.

  return ddoc.views[view].map;
}

function findKeys(ddoc, view, doc) {
  let strMapFunction = getMapFunction(ddoc, view);
  let keys = [];
  let mapFunction = evalFunctionWithEval(strMapFunction, (key, value) => {
    keys.push(key);
  });
  try {
    mapFunction(doc);
  } catch (e) {
    console.warn('findKeys: error while executing map function', ddoc._id, view, doc._id);
  }
  return keys;
}

function isKeyInRange(key, startKey, endKey, inclusiveStart, inclusiveEnd) {
  if (!startKey && !endKey) {
    return false;
  }

  let b1 = startKey ? (inclusiveStart ? collate(key, startKey) >= 0 : collate(key, startKey) > 0) : true;
  let b2 = endKey ? (inclusiveEnd ? collate(key, endKey) <= 0 : collate(key, endKey) < 0) : true;
  // console.log('isKeyInRange:', key, startKey, endKey, inclusiveEnd, b1, b2);
  return b1 && b2;
}

function isQueryEmpty(query) {
  if (!query) {
    return true;
  }

  return (!query.key && !query.keys && !query.startkey && !query.endkey);
}

function anyKeyMatchesQuery(keys = [], query) {
  if (!keys || keys.length == 0) {
    return false;
  }

  if (isQueryEmpty(query)) {
    return true;
  }
  
  let i;
  if (query.key || query.keys) {
    const queryKeys = query.keys || [];
    if (query.key) {
      queryKeys.push(query.key);
    }
    let queryKey, j, key;
    for (i = 0; i < queryKeys.length; i++) {
      queryKey = queryKeys[i];
      for (j = 0; j < keys.length; j++) {
        key = keys[j];
        if (collate(queryKey, key) == 0) {
          return true;
        }
      }
    }
    return false;
  }

  const startkey = query.descending ? query.endkey : query.startkey;
  const endkey = query.descending ? query.startkey : query.endkey;

  const inclusiveStart = !query.descending ? true : query.inclusive_end;
  const inclusiveEnd = query.descending ? true : query.inclusive_end;

  let key;
  for (i = 0; i < keys.length; i++) {
    key = keys[i];
    if (isKeyInRange(key, startkey, endkey, inclusiveStart, inclusiveEnd)) {
      return true;
    }
  }
  return false;
}


export { findKeys, anyKeyMatchesQuery };